import { dataLoading } from "@/shared/decorators/LoadingAction.decorator";
import apiClient from "./ApiClientService";
import { Terminal } from "@/shared/models/Terminal";
import { Product } from "@/shared/models/Product";
import { CountryRegionDomain } from "@/shared/models/CountryRegionDomain";
import { FaultCode } from "@/shared/models/FaultCode";

export class CommonApi {
  @dataLoading([])
  static async getTerminals() {
    var result = await apiClient.get("common/terminals");
    if (result.status === 200 && result.data) {
      const data = result.data as Terminal[];
      return data.sort((a, b) => a.name.localeCompare(b.name));
    } else {
      return [];
    }
  }

  @dataLoading([])
  static async getProducts() {
    var result = await apiClient.get("common/products");
    if (result.status === 200 && result.data) {
      const data = result.data as Product[];
      return data.sort((a, b) => a.displayProductName.localeCompare(b.displayProductName));
    } else {
      return [];
    }
  }

  @dataLoading([])
  static async getCountryRegionDomains() {
    var result = await apiClient.get("common/countryregiondomains");
    if (result.status === 200 && result.data) {
      return result.data as CountryRegionDomain[];
    } else {
      return [];
    }
  }

  @dataLoading([])
  static async getFaultCodes() {
    var result = await apiClient.get("faultcode/active");
    if (result.status === 200 && result.data) {
      const data = result.data as FaultCode[];
      return data.sort((a, b) => a.code.localeCompare(b.code));
    } else {
      return [];
    }
  }
}
